import React from 'react';
import '../general/General.css';
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";


const Arayanadu = () => {
    return (
        <>
            <Navbar />
            <div className="general_parent">
                <div className="general_container">
                    <div className="general_body">
                        <Breadcrumbs /><br />
                        <h2> <b>அரையநாடு</b></h2>
                        <br></br>

                        <p>கொங்கு 24 நாடுகளில் அரையநாடு மிகவும் இன்றியமையாத சிறப்புமிக்கது. சங்க காலத்தில் ஆமூர்க் கவுதமன் சாதேவனார் என்ற புலவரால் கொடுமுடி என்ற மன்னன் பாராட்டி பாடப்பட்டள்ளான். அகநானூறு 159ஆம் பாடலில் அக்கொடுமுடி என்ற மாவீரன் குறிக்கப்படுகின்றான். கொடுமுடி என்ற அம்மன்னன் பெயராலேயே அரையநாட்டுக் கொடுமுடிக்கும் பெயர் ஏற்பட்டது. </p>
                        <p>புறநானூற்றில் 202 ஆம் பாடலில் கபிலர், சிற்றரையம், பேரரையம் என்ற இரு பெயரால் இரண்டாகப் பகுக்கப்பட்ட பண்டைய ஊரொன்றைக் குறித்துப் பாடியுள்ளார். </p>

                        <div className="notes">

                            &QUOT;இருபாற் பெயரிய உருகெழு மூதூர்க்<br />
                            கோடிபல அடுக்கிய பொருள்நுமக்கு உதவிய<br />
                            நீடுநிரை அரையம்&QUOT;<br />

                        </div>
                        <p>என்பது அவர் பாடிய பாடல்பகுதி. அச்சங்க இலக்கியம் குறிக்கும் அரையம் என்ற பெயராலேயே அரையநாடு பெயர்பெற்றது என்ற கருத்து ஆய்வாளர்களால் கூறப்படுகிறது.</p>

                        <p>திருவரங்கம் கோயிலில் அரையர் சேலை என்ற வழிபாட்டுமுறை ஒன்றுண்டு. அரசர் என்ற பெயர் அரைசர் எனமாறி அரையர் என்று ஆவது உண்டு. &QUOT;அரையர்கோவை&QUOT; என்ற இலக்கியமும் ஒன்றுண்டு. கொடுமுடி என்ற அரசன், இளவரச நல்லூர், சேர அரசன் ஆட்டன் ஆத்தி ஆகியோர் தொடர்பாலும்கூட அரையநாடு என்ற பெயர் பெற்றிருக்கலாம். பல்லவராயர், கச்சிராயர், காடவராயர் போன்ற பட்டப் பெயர்கள் பல்லவரையர், கச்சிரையர், காடவரையர் என்றும் குறிக்கப்படும் அப்பெயர்களாலும் அரையநாடு என்ற பெயர் பெற்றிருக்கலாம்.
                        </p>

                        <p>மேற்கண்ட தலைவன் பெயரால் அமைந்த கொடுமுடியைத் தேவாரம் பாடிய மூவரும் பாடியுள்ளனர்.</p>
                        <p>&QUOT;பரந்திழி காவிரிப் பாங்கர்ப் பாண்டிக் கொடுமுடி&QUOT; என்று திருஞானசம்பந்தரும்,</p>
                        <p>&QUOT;திருபாண்டிக்கொடுமுடி&QUOT; என்று திருநாவுக்கரசரும்?</p>
                        <p>&QUOT;சீர் கறையாரில் பாண்டிக்கொடுமுடி&QUOT; என்று சுந்தரரும் பாடியுள்ளனர். </p>
                        <p>மாணிக்கவாசகர்,

                            &QUOT;பாண்டி வெள்ளமே&QUOT; என்பார். எனவே சமய குரவர் நால்வரும் பாடிய கொங்குத்தலம் கொடுமுடி ஒன்றேயாகும்.</p>

                        <p>சைவத் திருமுறைகளில் &QUOT;மாக்கறைசை&QUOT; என்று தனிப்பாடல் ஒன்று கொடுமுடியைப் புகழும் பதினோராம் திருமுறையில் உள்ள திரு இரட்டை மணிமாலையில் </p>
                        <p>&QUOT;நறுந்தேன் படுமுடியாய பாய் பரந்தொழுகு
                            பாண்டிக் கொடுமுடி&QUOT;</p>

                        <p>என்றும் சேக்கிழாரின் பெரியபுராணம் என்னும் சைவப் பன்னிரண்டாம் திருமுறையில்,</p>

                        <p>&QUOT;குரவயர் சோலை அணிதிருப் பாண்டிக் கொடுமுடி&QUOT;</p>
                        <p> &QUOT;கொங்கினில் பொன்னித் தென்கரைக் கறையூர்க் கொடுமுடி&QUOT;</p>
                        <p> &QUOT;செப்பரும் சீர்க் கொடுமுடி&QUOT;</p>
                        <p> &QUOT;பருவமறாப் பொன்னிப் பாண்டிக் கொடுமுடி&QUOT;</p>
                        <p>என்றும் கொடுமுடி பலப புகழப்பட்டுள்ளது. சைவ சிறப்புமிக்க இக்கொடுமுடியோடு நெருங்கிய தொடர்புடையது விதரி அத்திப்பாளையம்.</p>

                        <p>அரையநாடு மிகப் பரந்துபட்டுள்ளதால் காவிரிக்கும் கிழக்கேயுள்ள பகுதி கீழ்க்கரை அரையநாடு என்றும், காயிரிக்கு மேற்கேயுள்ள பகுதி மேல்கரை அரையநாடு என்றும் அழைக்கப்பட்டது.</p>
                        <p>கீழ்க்கரை அரையநாட்டில் 32 ஊர்கள் உள்ளன. மேல்கரை அரையநாட்டில் தலையநல்லூர், வெங்கம்பூர், அஞ்சூர், மொஞ்சனூர், கொல்லங்கோயில், கொந்தளம்,துக்காச்சிகார்வழி கொடுமுடி விதரி, எழுநாற்றுமங்களம்,இளவரசநல்லூர், வல்லிபுரம் வடிவுடையமங்கலம், ஊஞ்சலூர், திருக்காடுதுறை ஆகிய 16 ஊர்கள் விளங்குகின்றன. </p>

                        <p>இவைகளைத் தொகுத்து ஊர்த்தொகைப் பாடல் கூறுகிறது.</p>

                        <div className="notes">

                            &QUOT;என்னில மெனுந்தலசை வெங்கநகர் அஞ்சூரு <br />

                            இம்பர்மகிழ் மொஞ்சனூரும் <br />

                            இன்பமாக வளர்கொல்லன்கோயில் மிகுகொந்தளம் <br />

                            எழிலாக வருகறைசையும் <br />

                            மன்னவர் உறும் விதரி எழுநாற்றுமங்களம்  <br />

                            வண்மையிளவரசநல்லூர் <br />

                            வல்லிபுரம் கார்வழியினோடு துக்காச்சியும் <br />

                            வடிவுடைய நகஞ்ஞ்சலூர்  <br />

                            முன்னிலைமையாகத் திருக்காடுதுறையுடன் <br />

                            முத்தமிழர் கொண்டாடவே <br />

                            முற்றுமே இந்திரன் பதிபோல் விளங்கியே <br />

                            மொய்ம்பேற வேதழைத்து <br />

                            அன்னவயல் சூழ்கதலி தென்னை மாதுளைபுன்னை <br />

                            அரசு நிலைபூகமாதி <br />

                            அரியதரு நீடு பூஞ்சோலை சூழ்ந்தோங்கும் <br />

                            அரைய நன்னாடுதானே &QUOT; <br />
                        </div>
                        <p>இப்பதினாறு ஊர்களையும் நாடு எட்டுத் தானம் எட்டு என்று பிரிப்பர். அரையநாட்டு சபைக்குரிய ஊர்கள் எட்டு கொடுமுடி கோயில்களின் தேவஸ்தானத்திற்கு கொடையாக விடப்பட்ட ஊர்கள் எட்டாகும்.</p>

                        <p>தலையநல்லூர், வெங்கம்பூர், அஞ்சூர், மொஞ்சனூர், கொல்லங்கோயில், கொந்தளம், துக்காச்சி, கார்வழி ஆகிய எட்டுர்கள் அரையநாட்டு சபைக்குரிய ஊர்கள், கொடுமுடி, விதரி, எழுநூற்றுமங்களம், இளவரசநல்லூர், வல்லிபுரம், வடிவுள்ளமங்கை, ஊஞ்சலூர்,திருக்காடுதுறை ஆகிய எட்டுஊர்கள் தானக்கிராமமாகும்.</p>
                        <div className="notes">

                            &QUOT;உலகப்புகழ் தலையநல்லூர் வெங்கப்பூருடன்<br />
                            உயர்ச்சிபெறும் அஞ்குரும்<br />
                            உசிதமிகு புகழ்குலவு மொஞ்சனூர் கொல்லங்கோயில்<br />
                            உண்தைய கொந்தளம்<br />
                            நலமிகும் துக்காச்சி கார்வழிக்கிராமம் இரு<br />
                            நான்குமேல் கரையரையதன்<br />
                            நாடதற்குரிய வாம் தானக்கிராபம் இரு<br />
                            நான்கு மகுடேலிங்கர் <br />
                            தலமெனும் கறை செயம்பதி விதரி மிகுநலம்<br />
                            சார்ந்த எழுநாற்றினங்கை<br />
                            தங்கும் இளவரசநல்லூர் வல்லிபுரம் எழில்<br />
                            தான் கொளிவடிவுள்ளமங்கை<br />
                            நிலைபெறும் ஊஞ்சலூர் திருக்காடுதுறையென <br />
                            நிகழ்த்துபதி பொன்னிகாஞ்சி <br />
                            நீண்ட அனுபாந்தி துலங்கு நன் வீதிகள்<br />
                            நிறைந்து வளர் அரையநாடே&QUOT;<br />
                        </div>
                        <p>என்னும்பாடல் மூலம் நாட்டு ஊர்கள் எட்டையும், கொடுமுடி மகுடீசுவரர் தானஊர்கள் எட்டையும் அறிகிறோம். </p>
                        <p>இச்செய்தி கொடுமுடி வீரநாராயணப் பெருமாள் கோயில் கல்வெட்டொன்றாலும் உறுதிப்படுகிறது.</p>
                        <div className="notes">

                            ஸ்வஸ்தரீமனுமக<br />
                            மண்டலேசுரன்<br />
                            நிம்ப மாலிகாபரணன் மக<br />
                            வம்சம் ரகுவம்ச மதிகுலாதிப திரிபு<br />
                            வள சக்கறவத்திகளா<br />
                            கிய கோ வீரசுந்தரபாண<br />
                            ல் சோலருமன்சமலி திரிபுவன <br />
                            மகாதேவ தேவோத்தமன் செம்புத் <br />
                            தீவில் திராவிட தேசத்தில்<br />
                            அதிராசராச மண்டலத்தில்<br />
                            தெட்ச கயிலாச துல்லியமாகிய<br />
                            மேல்கரையரைய நாட்டில் <br />
                            நற்காவிரிகுளுந் திருப்பாண்டிக் <br />
                            கொடுமுடியாளுடைய நன்னாயநாற் <br />
                            குடி பெரிய திருவடிநாயனாற்கும்<br />
                            இறையிலி தேவஸ்தானமாக<br />
                            உதகம் பண்ணிக்குடுத்து <br />
                            ஊராவது கறையூர்,<br />
                            விதரித் திருச்சிற்றம்பநல்லூர், <br />
                            நன்னாயனார் திருவிடையாட்டத் <br />
                            தெழுநூற்றுச் சருப்பேதி மங்கலம்,<br />
                            திரு ஊஞ்சலூர், வல்லிபுரம்,<br />
                            வடிவுடையமங்கலம்,ஐயந்தரு<br />
                            திருக்காடுதுறையும் நாயனார் <br />
                            திருப்பாண்டிக் கொடுமுடி <br />
                            யாளுடைடியகேசரி<br />
                            பன்மரான தேவர்க்கு யாண்டு <br />
                            இரண்டாவது மாசி மாதம் 14 தேதி<br />
                            ஆதித்த வாரமும் மகா <br />
                            நட்செத்திரமும் சித்திநாமயோகமும்<br />
                            பர்ல வாகரணமும் கூடிய யின்னாளி<br />
                            யாற்கும் பெரிய திருவடியா<br />
                            நன்னாயனாற்கும் மாசிமகத் திருவிளா<br />
                            எழுந்தருளவும் தபனமாடியருளவும்<br />
                            சற்கால நிபந்தங்களுக்கும் பெருந்த<br />
                            திருவமுது செய்தருளவும் <br />
                            சாத்துப்படி திருவாராதனமும்<br />
                            திருப்பணிகளுக்குங் குறைவற <br />
                            நடத்திப் போந்தருளவும் இதுக்கடலாயெப் <br />
                            பேர்ப்பட்ட ப்ராப்திகளுக்கும் நீகந்<br />
                            தரத்திருப்பாண்டிக் கொடுமுடி<br />
                            மஹதேவர்க்குப் பெரிய <br />
                            திருவடினாயணாருக்கும் இவ்வூர்க <br />
                            களுதகம் பண்ணிக் குடுத்தோ<br />
                            யிவ்வூர்க ளெல்லை அனைத்தி<br />
                            ற்கும் திரிசூல தாபனம்சக்கரதாபனம்<br />
                            கல்லிலுஞ் செம்பிலும் <br />
                            வெட்டிக்கொள்வதாகவும் உ<br />
                        </div>

                        <p>என்பது கொடுமுடிக் கல்வெட்டு. இதில் விதரிக்குத் திருச்சிற்றம்பல நல்லூர் என்ற பெயரும்கொ டுக்கப்பட்டிருப்பது இதன் சமயப் பெருமைக்கு சிறந்த எடுத்துக்காட்டாக உள்ளது. </p>

                        <p>ஊஞ்சலூர் நாகீசுவார் கோயில் கல்வெட்டிலும் அவ்வூர் கொடுமுடி லிங்கருக்கும் வீரநாராயணப் பெருமாளுக்கும் கொடையாக கொடுக்கப்பட்டுள்ள விபரம் கூறப்பட்டுள்ளது.</p>
                        <p> விதரியைக் கொடுமுடிக் கோயிலுக்குக் கொடையாக அளிக்கப்பட்டுள்ள விபரம் கல்வெட்டில் பொறிக்கப்பட்டதுடன் செப்பேட்டிலும் எழுதப்பட்டுள்ளதாக கூறப்படுகிறது. ஆனால் செப்பேடு எதுவும் கிடைக்கவில்லை. விதரியான திருச்சிற்றம்பலநல்லூரில் நான்கு எல்லைகளிலும் திரிசூலம் பொறிக்கப்பட்ட கற்கள் நடப்பட்டுள்ளதாக கூறப்பட்டுள்ளது.</p>

                        <p>நல்லூர், மங்கலம் என்பதை தொன்மை வாய்ந்த சமயச் சிறப்புடைய ஊர்களாகும். விதரி-திருச்சிற்றம்பல நல்லூர் என்று பெயர் பெற்றிருப்பது தானக் கிராமங்கள் இரண்டூர்கள் எழுநாற்றுச் சருப்பேதி மங்கலம் வடிவுடையமங்கலம் எனப் பெயர் பெற்றிருப்பதும் சிறப்புக்குரியதாகும்.</p>

                        <p>அரையநாட்டுப் பாடல்கள் இரண்டிலும் அரையநாட்டின் வளம் சிறப்பாகக் கூறப்பட்டுள்ளது. அதற்குக் காரணம் காவிரி, நொய்யல், அனுமநதி முதலிய மூன்று ஆறுகள் இங்கு பாயும் சிறப்புக் கூறப்பட்டுள்ளன. காலிங்கராயன் கால்வாயும் வளத்துக்கொரு காரணம் அதனால்தான் </p>
                        <div className="notes">

                            &QUOT;தழைத்து அன்னவயல் சூழ்கதலி தென்னைமாதுளைபுன்னை<br />

                            அரசு நிலைபூகமாதி அரியதரு நீடு பூஞ்சோலை <br />

                            சூழ்ந் தோங்குமேல் அரையநன் நாடுதானே&QUOT;<br />


                            <p>என்று கூறப்பட்டுள்ளது.</p>

                            <p>கி.பி. 1800 இல் இப்பகுதிக்கு வந்த ஆங்கிலப் பயணி கொடுமுடி அருகில் உள்ள வளமான பகுதியைப் போல் உலகில் எங்கும் தாம் கண்டதில்லை என்று கூறியுள்ளார்.</p>


                            <br /><br /><br />

                        </div>
                    </div>
                </div>
            </div >
            <Footer /></>
    );
}
export default Arayanadu;